import { render, staticRenderFns } from "./WqMessageRevPersonForm.vue?vue&type=template&id=c692603c&scoped=true"
import script from "./WqMessageRevPersonForm.vue?vue&type=script&lang=js"
export * from "./WqMessageRevPersonForm.vue?vue&type=script&lang=js"
import style0 from "./WqMessageRevPersonForm.vue?vue&type=style&index=0&id=c692603c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c692603c",
  null
  
)

export default component.exports